module.exports = __webpack_public_path__ + "img/CH.d3779981.svg";